import { Box, Button, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip, Typography } from "@mui/material";
import { FC, MouseEvent, useState } from "react";
import { Link as RouterLink, matchPath, useLocation } from 'react-router-dom'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import DbDeployment from "~/icons/DbDeployment";
import DbEncryption from "~/icons/DbEncryption";
import DbGovernance from "~/icons/DbGovernance";
import PerfTuning from "~/icons/PerfTuning";
//potential new icon
// import SecureFile from "~/icons/SecureFile";
import DbBackup from "~/icons/DbBackup";
import { useSelector } from "react-redux";
import { OnDataFeature } from "~/gen/api/user";
import { getUserProfile } from "~/reducers/userProfile";


const ServicesMenu: FC = () => {
  const location = useLocation()
  const match = matchPath<{rest:string}>(location.pathname, { path: '/:rest' })

  const { rest: activeItem } = match?.params || {}

  const [anchorEl, setAnchorEl] = useState<any>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: MouseEvent) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // should put MenuItem directly under Menu component, <WhenPermit /> will not work
  const hasSecureFileFeature = useSelector(store => Boolean(getUserProfile(store)?.features?.some(f => f.featureId === OnDataFeature.OnDataSecureFile)))

  return (
    <Box>
      <Button
        id="services-menu-button"
        aria-controls="services-menu"
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        size="medium"
        sx={{ color: theme => theme.palette.mode === 'light' ? theme.palette.primary.contrastText : theme.palette.text.primary }}
        variant="outlined"
        color="secondary"
        endIcon={<ArrowDropDownIcon />}
      >
        Services
      </Button>
      <Menu
        id="services-menu"
        aria-labelledby="services-menu-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >

          <MenuItem component={RouterLink} to="/governance" onClick={handleClose} selected={"governance" === activeItem}>
            <ListItemIcon>
              <DbGovernance sx={{ color: 'primary.light' }} />
            </ListItemIcon>
            <ListItemText
              primary={(
                <Typography
                  color="textPrimary"
                  variant="subtitle2"
                >
                  Data Catalog
                </Typography>
              )}
            />
          </MenuItem>

          <MenuItem component={RouterLink} to="/encryption" onClick={handleClose} selected={"encryption" === activeItem}>
            <ListItemIcon>
              <DbEncryption sx={{ color: 'primary.light' }} />
            </ListItemIcon>
            <ListItemText
              primary={(
                <Typography
                  color="textPrimary"
                  variant="subtitle2"
                >
                  Encryption
                </Typography>
              )}
            />
          </MenuItem>

          <MenuItem component={RouterLink} to="/backups-n-validations" onClick={handleClose} selected={"backups-n-validations" === activeItem}>
            <ListItemIcon>
              <DbBackup sx={{ color: 'primary.light' }} />
            </ListItemIcon>
            <ListItemText
              primary={(
                <Typography
                  color="textPrimary"
                  variant="subtitle2"
                >
                  Continuity
                </Typography>
              )}
            />
          </MenuItem>

          <MenuItem component={RouterLink} to="/deployments" onClick={handleClose} selected={"deployments" === activeItem}>
            <ListItemIcon>
              <DbDeployment sx={{ color: 'primary.light' }} />
            </ListItemIcon>
            <ListItemText
              primary={(
                <Typography
                  color="textPrimary"
                  variant="subtitle2"
                >
                  Deployment
                </Typography>
              )}
            />
          </MenuItem>
          {hasSecureFileFeature &&
            <MenuItem component={RouterLink} to="/secure-files" onClick={handleClose} selected={"secure-files" === activeItem}>
              <ListItemIcon>
                {/*Reusing Performance Tuning Icon for now*/}
                <PerfTuning sx={{ color: 'primary.light' }} />
              </ListItemIcon>
              <ListItemText
                primary={(
                  <Typography
                    color="textPrimary"
                    variant="subtitle2"
                  >
                    SecureFile
                  </Typography>
                )}
              />
            </MenuItem>}
       {/* Disable performance tuning menu item
        <Tooltip title="This feature will be available in next release" placement="right">
          <MenuItem component={RouterLink} to="/performance-tuning" onClick={handleClose} selected={"performance-tuning" === activeItem}>
            <ListItemIcon>
              <PerfTuning sx={{ color: 'primary.light' }} />
            </ListItemIcon>
            <ListItemText
              primary={(
                <Typography
                  color="textPrimary"
                  variant="subtitle2"
                >
                  Performance
                </Typography>
              )}
            />
          </MenuItem>
        </Tooltip> */}
      </Menu>
    </Box>
  )
}

export default ServicesMenu;
